import $ from 'jquery';
import React from 'react';

const DeleteActivity = (props) => {
    let onConfirmDelete = () => {
        props.onConfirmDelete(props.activity.activity_id);
        $('.btn-close').trigger('click');
    }
    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
            </div>
            <div className="modal-body">
                <div className="text-center">
                    Are you sure you want to delete settings ?<br />
                    <b>"{props.activity.activity_name}"</b>
                </div>
            </div>
            <div className="modal-footer bg-light py-1">
                <span className="pull-right">
                    <button type='button' className='btn btn-white btn-sm mr-2 btn-close' data-dismiss='modal' onClick={props.closeModal}>No</button>
                    <button type='button' className='btn btn-sm btn-primary' data-dismiss='modal' onClick={onConfirmDelete}>Yes, Please</button>
                </span>
            </div>

        </React.Fragment>
    );
}

export default DeleteActivity;